export default __webpack_public_path__ + "static/media/oasis.57458152.jpg";